export default __webpack_public_path__ + "static/media/ClodSorting.c41db42b.jpg";